import _toConsumableArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMessageList, ReadInfo, MessageAllRead } from "@/api/system/message";
export default {
  name: "messageList",
  data: function data() {
    return {
      drawer: false,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        sort: "desc",
        keyword: "",
        type: ""
      },
      list: [],
      activeItem: {},
      loading: true,
      visible: false,
      finish: false,
      info: {},
      infos: {}
    };
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.finish = false;
      this.drawer = true;
      this.listQuery.currentPage = 1;
      this.list = [];
      this.getList();
      this.$nextTick(function () {
        _this2.bindScroll();
      });
    },
    getList: function getList() {
      var _this3 = this;
      this.loading = true;
      getMessageList(this.listQuery).then(function (res) {
        if (res.data.list.length < _this3.listQuery.pageSize) {
          _this3.finish = true;
        }
        _this3.list = [].concat(_toConsumableArray(_this3.list), _toConsumableArray(res.data.list));
        console.log(_this3.list);
        _this3.loading = false;
      });
    },
    bindScroll: function bindScroll() {
      var _this = this,
        vBody = _this.$refs.messageListBody;
      vBody.addEventListener("scroll", function () {
        if (vBody.scrollHeight - vBody.clientHeight - vBody.scrollTop <= 200 && !_this.loading && !_this.finish) {
          _this.listQuery.currentPage += 1;
          _this.getList();
        }
      });
    },
    readInfo: function readInfo(item) {
      var _this4 = this;
      ReadInfo(item.id).then(function (res) {
        console.log(res.data);
        _this4.info = res.data;
        if (item.isRead == "0") {
          item.isRead = "1";
          _this4.$emit("read");
        }
        if (item.type == 1) {
          _this4.visible = true;
        } else {
          // let body = this.info.bodyText ? JSON.parse(this.info.bodyText) : {};
          // let url = "flowLaunch";
          // if (body.type == 2) url = "flowTodo";
          // if (body.type == 3) url = "flowCirculate";
          // this.drawer = false;

          _this4.$router.push("/messageRecord");
        }
      });
    },
    gotoCenter: function gotoCenter() {
      this.drawer = false;
      this.$router.push("/messageRecord");
    },
    readAll: function readAll() {
      var _this5 = this;
      this.$confirm("您确定全部为已读状态, 是否继续?", "提示", {
        type: "warning"
      }).then(function () {
        MessageAllRead().then(function (res) {
          _this5.$message({
            message: res.msg,
            type: "success",
            duration: 1500,
            onClose: function onClose() {
              _this5.$emit("read", true);
              for (var i = 0; i < _this5.list.length; i++) {
                _this5.$set(_this5.list[i], "isRead", "1");
              }
            }
          });
        });
      }).catch(function () {});
    },
    handleClose: function handleClose(done) {
      var vBody = this.$refs.messageListBody;
      vBody.removeEventListener("scroll", function () {});
      done();
    }
  }
};